import React from "react";
import { Box, Typography } from "@mui/material";
import DocumentItem from "components/Documents/StepZeroDocuments/stepZeroDocument"; 

const RuractiveCanvaDownload = () => {
  return (
    <Box 
      sx={{ 
        mt: 2, 
        mb: 4, 
        p: 2.5, 
        borderRadius: 2, 
        backgroundColor: "#F8FAFC", 
        border: "1px solid #E4E7EC", 
        borderLeft: "4px solid #23576B"
      }}
    >
      <Typography variant="subtitle1" sx={{ fontWeight: 600, color: "#23576B", mb: 1 }}>
        RURACTIVE Canva - LW3
      </Typography>
      
      <Typography variant="body2" sx={{ color: "#667085", mb: 3, lineHeight: 1.6 }}>
        This workshop focuses on fine-tuning your solutions, paying particular attention to the integration of Cross-Cutting Priorities (CCPs), gender issues, and forms of innovation. 
        <br /><br />
        Download the <strong>RURACTIVE Canva</strong> below. It will help you develop a clear implementation plan by mapping synergies with existing projects, planning your objectives and targets, and defining the resources and capitals needed to kick-start your solution.
      </Typography>

      <Box sx={{ width: "100%" }}>
        <DocumentItem
          title="RURACTIVE_Canva_LW3"
          file="/documents/RURACTIVE_Canva_LW3.pdf" 
        />
      </Box>
    </Box>
  );
};

export default RuractiveCanvaDownload;